export default "__VITE_ASSET__CBWEQ4Wg__"